import { render, staticRenderFns } from "./loadgreensupplier.vue?vue&type=template&id=8583bc54&scoped=true&"
import script from "./loadgreensupplier.vue?vue&type=script&lang=js&"
export * from "./loadgreensupplier.vue?vue&type=script&lang=js&"
import style0 from "./loadgreensupplier.vue?vue&type=style&index=0&id=8583bc54&prod&lang=scss&scoped=true&"
import style1 from "./loadgreensupplier.vue?vue&type=style&index=1&id=8583bc54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8583bc54",
  null
  
)

export default component.exports